import { render, staticRenderFns } from "./ExampleComponent2.vue?vue&type=template&id=f2e957e0&scoped=true&"
import script from "./ExampleComponent2.vue?vue&type=script&lang=js&"
export * from "./ExampleComponent2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2e957e0",
  null
  
)

export default component.exports